import React, { useEffect } from 'react';
import dance from '../Assests/picsw.jpg';
import Aos from "aos";
import "aos/dist/aos.css";
import Slider from '../Components/Slider';
import Tools from '../Components/Tools';

const About = () => {
    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <div className='text-white overflow-x-hidden font-inria container'>
        <div className='grid grid-cols-1 lg:grid-cols-2 mx-4 md:mx-20 mt-16 md:mt-32 '>
            <div className=''>
                {/* <div className='mb-6 md:mb-10' data-aos="fade-left">
                    <p className='font-inria text-lg md:text-2xl text-gray-400 text-left font-thin'>
                        As a dancer, I express myself through movement, blending creativity with precision to convey stories and emotions. Dance is my passion and my language of expression.
                    </p>
                </div> */}
                <div className=' flex justify-center'>
                    <img src={dance} alt='dance' className=' h-[300px] w-[320px] md:h-[350px]  md:w-[550px]' data-aos='flip-left' style={{ maxWidth: '576px', borderRadius: '50px' }} />
                </div>
            </div>
            <div className='mt-10 lg:mt-0 flex justify-center' data-aos="fade-left">
                <div className='mx-4'>
                    <div className='mb-10'>
                        <h1 className='font-inria text-white text-3xl md:text-6xl font-medium'>ABOUT</h1>
                    </div>
                    <div className='mb-6 md:mb-10'>
                        <p className='font-inria text-lg md:text-2xl text-gray-400 text-justify font-thin'>I am a Full Stack Developer with a passion for building modern, responsive websites and applications. I focus on creating seamless user experiences, combining clean design with efficient, scalable solutions. Continuously learning and exploring new technologies, I thrive in solving complex problems and delivering high-quality digital products.</p>
                    </div>
                    {/* <div className='mb-6 md:mb-10'>
                        <p className='font-inria text-lg md:text-2xl text-gray-400 text-left font-thin mr-10'>
                            With a fervent enthusiasm for Web3, I'm passionate about leveraging blockchain technology to push the boundaries of innovation.
                        </p>
                    </div> */}
                </div>
            </div>
            
        </div>
        <div>
        <div className='flex justify-center mt-20 md:mt-28 mb-10 md:mb-20'>
        <h1 className='text-2xl md:text-5xl lg:text-6xl' data-aos="flip-up">What about my Tools & skills</h1>
      </div>
      <div className='mx-4 lg:mx-10'>
        <Tools/>
      </div>
        <div className='mt-10'>
            <Slider/>
        </div>
        </div>
        </div>
    );
};

export default About;
